import React, { Component } from 'react'
import { Button, Collapse, Dialog, Divider, IconButton, Paper, Typography, withStyles } from '@material-ui/core'
import { Backup, Delete, Edit } from '@material-ui/icons'
import autobind from '../../Utils/autobind'
import { connect } from 'react-redux'
import TextInput from '../../Shared/Inputs/TextInput'
import FileInput from '../../Shared/Inputs/FileInput'
import SelectInput from '../../Shared/Inputs/SelectInput'
import SubmitButton from '../../Shared/SubmitButton'
import { transformToOptions } from '../../Utils/functions'
import { withRouter } from 'react-router-dom'
import moment from 'moment'
import { createSubBranchDocumentAction, deleteSubBranchDocumentAction, editSubBranchDocumentAction, signDocumentAction } from '../../Actions/BranchActions'
import { callSnackbar } from '../../Utils/snackbar'
import DateInput from '../../Shared/Inputs/DateInput'
import SignDocument from '../Workers/SignDocument'
import ImageContainer from '../../Shared/ImageContainer'

const style = theme => ({
  category: {
    position: 'relative',
    transition: 'all 0.2s ease-in-out',
    height: 150,
    width: 250,
    "@media (max-width:500px)": {
      width: '100%',
    },
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    margin: '24px 0'
  },
  actions: {
    position: 'absolute',
    bottom: 12,
    left: 12,
    right: 12,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  categoryContainer: {
    padding: 12,
    transition: 'all 0.2s ease-in-out',
    "@media (max-width:500px)": {
      width: '100%',
      padding: "12px 0"
    },
  },
  mainCategory: {
    overflow: 'hidden',
    transition: 'all 0.2s ease-in-out',
  },
  openMain: {
    minHeight: 300,
    width: '100%',
    "@media (max-width:500px)": {
      width: '100%',
    },
  },
  closedMain: {
    height: 0,
    width: 0
  },
  title: {
    padding: 12,
    transition: 'all 0.2s ease-in-out',
  },
  content: {
    padding: 12
  },
  openTitle: {
    background: theme.palette.primary.main,
    color: "white",
  },
  wrong: {
    padding: 12,
    transition: 'all 0.2s ease-in-out',
    color: theme.palette.red.main
  },
  openWrong: {
    background: theme.palette.red.main,
    color: "white",
  },
  file: {
    width: 200,
    margin: 12,
    border: '1px solid #1a1a1a',
    borderRadius: 12,
    padding: 12,
    position: 'relative',
    "@media (max-width:500px)": {
      width: '100%',
      margin: "12px 0"
    },
  },
  subcategory: {
    position: 'relative',
    transition: 'all 0.2s ease-in-out',
    height: 159,
    width: 226,
    margin: 12,
    "@media (max-width:500px)": {
      width: '100%',
    },
    border: "1px solid #1a1a1a"
  },
  files: {
    display: 'flex',
    padding: 12,
    flexWrap: 'wrap',
  },
  doctText: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    margin: '6px 0'
  },
  doctTextDownload: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    margin: '6px 0',
    color: theme.palette.blue.main,
    cursor: 'pointer'
  },
  doctTextTitle: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    margin: '6px 0',
    fontWeight: 600
  },
  docButtons: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 12
  },
  inputs: {
    padding: 12
  },
  warningContainer: {
    padding: "0px 6px 6px"
  },
  warning: {
    color: theme.palette.red.main,
    margin: "6px 0",
    fontWeight: 600
  },
  signButton: {
    position: 'absolute',
    top: 58,
    right: 12,
    textAlign: 'end',
    '& > div > span': {
      color: theme.palette.green.main
    }
  },
  docSigns: {
    padding: 12,
    display: 'flex',
    flexWrap: 'wrap',
  },
  docSign: {
    width: 240,
    padding: 12,
    margin: 12,
    "@media (max-width:500px)": {
      width: '100%',
    },
  },
  signTitle: {
    color: 'white',
    background: theme.palette.primary.main,
    padding: 12
  },
  caption: {
    textAlign: 'end'
  },
})

class SubBranchDocuments extends Component {
  constructor() {
    super()
    this.state = {
      openCategory: -1,
      openSubcategory: -1,
      category: {},
      subcategory: null,
      document: {},
      openDialog: false,
      openWarning: false,
      isSubEdit: false,
      openCreate: false,
      openNameWarning: null,
      selectedDocument: null,
      openSigns: null,
      params: {
        date: moment(new Date()).format("YYYY-MM-DD")
      },
      editParams: {}
    }

    autobind(SubBranchDocuments, this)
  }

  handleOpenCategory = (index, category, isSub = false) => () => {
    const { openCategory, openSubcategory } = this.state
    if (isSub) {
      if (openSubcategory === index) {
        this.setState({ openSubcategory: -1, subcategory: null })
      } else {
        this.setState({ openSubcategory: index, subcategory: category })
      }
    } else {
      if (openCategory === index) {
        this.setState({ openCategory: -1, category: {}, subcategory: null, openSubcategory: -1 })
      } else {
        this.setState({ openCategory: index, category, subcategory: null, openSubcategory: -1 })
        function showElement() {
          document.getElementById("openDocument").scrollIntoView({ behavior: "smooth" })
        }
        setTimeout(showElement, 500)
      }
    }
  }

  handleOpenSigns(document) {
    return () => {
      this.setState({ openSigns: document })
    }
  }

  handleOpenSign(document) {
    return () => {
      this.setState({ selectedDocument: document })
    }
  }

  handleOpenDialog(document) {
    return () => {
      if (document) {
        const editParams = {
          name: document.name,
          category_id: document.category_id,
          subcategory_id: document.subcategory_id,
          date: document.date || moment(new Date()).format("YYYY-MM-DD")
        }
        this.setState({ openDialog: !this.state.openDialog, document, editParams })
      } else {
        this.setState({ openDialog: !this.state.openDialog })
      }

    }
  }

  handleOpenWarning(document) {
    return () => {
      if (document) {
        this.setState({ openWarning: !this.state.openWarning, document })
      } else {
        this.setState({ openWarning: !this.state.openWarning })
      }
    }
  }

  handleOpenCreate(category, isSub = false) {
    return () => {
      if (category) {
        this.setState({ openCreate: !this.state.openCreate, isSubEdit: isSub, params: { ...this.state.params, category_id: category.id } })
      } else {
        this.setState({ openCreate: !this.state.openCreate, isSubEdit: isSub, params: {} })
      }

    }
  }

  handleChange(event) {
    const { target } = event
    const { params } = this.state
    const { branch } = this.props
    params[target.name] = target.value
    let existsName = null
    if (target.name === "file") {
      params["name"] = target.value.name
      const allDocuments = branch.sub_branch_documents || []
      existsName = allDocuments.find(doc => doc.name === target.value.name)
    }
    if (target.name === "name" && target.value !== "") {
      const allDocuments = branch.sub_branch_documents || []
      existsName = allDocuments.find(doc => doc.name === target.value)
    }
    if (existsName) {
      this.setState({ params, openNameWarning: existsName })
    } else {
      this.setState({ params, openNameWarning: null })
    }
  }

  handleChangeEdit(event) {
    const { target } = event
    const { editParams } = this.state
    const { branch } = this.props
    editParams[target.name] = target.value
    let existsName = null
    if (target.name === "file") {
      editParams["name"] = target.value.name
      const allDocuments = branch.sub_branch_documents || []
      existsName = allDocuments.find(doc => doc.name === target.value.name)
    }
    if (target.name === "name" && target.value !== "") {
      const allDocuments = branch.sub_branch_documents || []
      existsName = allDocuments.find(doc => doc.name === target.value)
    }
    if (existsName) {
      this.setState({ editParams, openNameWarning: existsName })
    } else {
      this.setState({ editParams, openNameWarning: null })
    }
  }

  handleSendEdit() {
    const { editParams, document } = this.state
    const { match, editSubBranchDocument } = this.props
    const body = new FormData()
    body.append("name", editParams.name)
    body.append("file", editParams.file)
    body.append("category_id", editParams.category_id)
    body.append("subcategory_id", editParams.subcategory_id)
    body.append("id", document.id)
    body.append("sub_branch_id", match.params.sub_branch_id)
    body.append("date", editParams.date)
    editSubBranchDocument(body)

    this.setState({ openDialog: false, document: {} })
  }

  handleSendDelete() {
    const { document } = this.state
    const { match, deleteSubBranchDocument } = this.props
    const body = {
      sub_branch_id: match.params.sub_branch_id,
      id: document.id
    }
    deleteSubBranchDocument(body)
    this.setState({ openWarning: false, document: {} })
  }

  handleCreate() {
    const { params, isSubEdit, category } = this.state
    const { match, createSubBranchDocument } = this.props
    const body = new FormData()
    body.append("name", params.name || "")
    body.append("file", params.file)
    body.append("date", params.date)
    body.append("sub_branch_id", match.params.sub_branch_id)
    if (isSubEdit) {
      body.append("category_id", category.id)
      body.append("subcategory_id", params.category_id)
    } else {
      body.append("category_id", params.category_id)
    }
    createSubBranchDocument(body)
    this.setState({ openCreate: false, params: {} })
  }

  handleDownload(element) {
    return () => {
      const url = `${process.env.REACT_APP_IMG_URL}${process.env.REACT_APP_SUB_BRANCH_DOCS}${element.file}`
      fetch(url).then((response) => {
        response.blob().then((blob) => {
          let url = window.URL.createObjectURL(blob)
          let a = document.createElement("a")
          a.href = url
          a.download = `${element.file}`
          a.click()
        })
      }).catch(() => callSnackbar("Error al descargar documento", "error"))
    }
  }

  handleSeeDocument(element) {
    return () => {
      window.open(`${process.env.REACT_APP_IMG_URL}${process.env.REACT_APP_SUB_BRANCH_DOCS}${element.file}`)
    }
  }

  renderSigns() {
    const { classes } = this.props
    const { openSigns } = this.state
    const signs = openSigns?.signs || []
    if (signs.length > 0) {
      return signs.map(sign => {
        const url = `${process.env.REACT_APP_IMG_URL}${process.env.REACT_APP_USER_SIGNS}${sign.sign}`
        return (
          <Paper className={classes.docSign}>
            <Typography variant="subtitle1">{sign.name}</Typography>
            <ImageContainer src={url || "/noimage.png"} height="100px" width="200" />
            <div className={classes.caption}>
              <Typography variant="caption">{moment(sign.date).format("YYYY-MM-DD HH:mm:ss")}</Typography>
            </div>
          </Paper>
        )
      })
    } else {
      return (
        <div>
          <Typography variant="subtitle1">No hay firmas aún en el documento</Typography>
        </div>
      )
    }

  }

  renderCategories() {
    const { openCategory } = this.state
    const { categories, classes, branch, user } = this.props

    const level = user.account.user.userType
    const cantEdit = level > 1

    const allDocuments = branch.sub_branch_documents || []
    const realCategories = categories.map((category, index) => {
      let isUpToDate = true
      const categoryDocuments = allDocuments.filter(document => document.category_id === category.id) || []

      if (category.frequency === 30) {
        const cutDate = moment(new Date()).startOf("month").add(category.cut_day, 'days')
        if (moment(new Date()) >= cutDate) {
          const validDocs = categoryDocuments.filter(doc => moment(doc.date).isSame(new Date(), "month"))
          if (validDocs.length === 0) {
            isUpToDate = false
          }
        }
      }

      if (category.frequency === 365) {
        const cutDate = moment(new Date()).startOf("year").add(category.cut_day, 'months')
        if (moment(new Date()) >= cutDate) {
          const validDocs = categoryDocuments.filter(doc => moment(doc.date).isSame(new Date(), "year"))
          if (validDocs.length === 0) {
            isUpToDate = false
          }
        }
      }

      if (category.frequency === 1 && categoryDocuments.length === 0) isUpToDate = false

      const isOpen = openCategory === index

      return (
        <div className={`${classes.categoryContainer}`} key={index}>
          <Paper className={`${classes.category}`}>
            <Typography variant="h1" className={`${isUpToDate ? classes.title : classes.wrong} ${isOpen ? (!isUpToDate ? classes.openWrong : classes.openTitle) : ""}`} > {category.name}</Typography>
            <Divider />
            <div className={classes.content}>
              <Typography variant="subtitle1"> Documentos: {categoryDocuments.length}</Typography>
              <div className={classes.actions}>
                <Button color="primary" variant="contained" onClick={this.handleOpenCategory(index, category)}>
                  {isOpen ? "Cerrar" : "Abrir"}
                </Button>
                <Button disabled={cantEdit} color="primary" variant="outlined" onClick={this.handleOpenCreate(category)}>
                  <Backup />
                </Button>
              </div>
            </div>
          </Paper>
        </div>
      )
    })
    const isGeneralOpen = openCategory === "none"
    const noCategoryDocuments = allDocuments.filter(document => document.category_id === null) || []
    const total = noCategoryDocuments.length
    return (
      <>
        {realCategories}
        {total > 0 &&
          <div className={`${classes.categoryContainer}`}>
            <Paper className={`${classes.category}`}>
              <Typography variant="h1" className={`${classes.title} ${isGeneralOpen ? classes.openTitle : ""}`}>Sin Categoría</Typography>
              <Divider />
              <div className={classes.content}>
                <Typography variant="subtitle1"> Documentos: {noCategoryDocuments.length}</Typography>
                <div className={classes.actions}>
                  <Button color="primary" variant="contained" onClick={this.handleOpenCategory("none", { id: null, name: "Sin Categoría" })}>
                    {isGeneralOpen ? "Cerrar" : "Abrir"}
                  </Button>
                </div>
              </div>
            </Paper>
          </div>
        }
      </>
    )
  }

  renderCategoryFiles() {
    const { category, subcategory } = this.state
    const { branch, classes, user } = this.props
    const level = user.account.user.userType
    const cantEdit = level > 1
    const allDocuments = branch.sub_branch_documents || []
    const docRender = allDocuments
      .filter(document => document.category_id === category.id
        && ((document.subcategory_id === 0 && !subcategory)
          || document.subcategory_id === subcategory?.id))
      .map(document => {
        return (
          <div className={classes.file} key={document.id}>
            <Typography variant="h2" className={classes.doctTextTitle}>{document.name || "Sin nombre"}</Typography>
            <Typography variant="body2" className={classes.doctTextDownload} onClick={this.handleSeeDocument(document)}>Ver Documento</Typography>
            <Typography variant="body2" className={classes.doctTextDownload} onClick={this.handleOpenSigns(document)}>Ver Firmas</Typography>
            <Typography variant="h2" className={classes.doctText}>{document.date}</Typography>
            <Divider />
            <div className={classes.docButtons}>
              {!cantEdit &&
                <div>
                  <IconButton size="small" onClick={this.handleOpenDialog(document)}>
                    <Edit />
                  </IconButton>
                  <IconButton size="small" onClick={this.handleOpenWarning(document)}>
                    <Delete />
                  </IconButton>
                </div>
              }
              <Button size="small" variant="outlined" color="primary" onClick={this.handleDownload(document)}>
                Descargar
            </Button>
            </div>
            <div className={classes.signButton}>
              <Button size="small" variant="outlined" onClick={this.handleOpenSign(document)} disabled={document.signs.map(sign => sign.user_id.toString()).includes(user.account.user.id.toString())}>
                Firmar
              </Button>
              <div>
                {document.signs.length > 0 && <Typography variant="caption">Firmado</Typography>}
              </div>
            </div>
          </div>
        )
      })
    return (
      <>
        {this.renderSubcategories()}
        {docRender}
      </>
    )
  }

  renderSubcategories() {
    const { category, openSubcategory } = this.state
    const { branch, classes, user } = this.props
    const level = user.account.user.userType
    const cantEdit = level > 1
    const allDocuments = branch.sub_branch_documents || []
    const allSubcategories = category.subcategories || []
    return allSubcategories.filter((subcat, index) => openSubcategory === -1 || openSubcategory === subcat.id).map((subcategory, index) => {
      const isSubOpen = openSubcategory === subcategory.id
      const subcategoryDocuments = allDocuments.filter(document => document.category_id === category.id && document.subcategory_id === subcategory.id) || []
      return (
        <div className={classes.subcategory} key={subcategory.id}>
          <Typography variant="h1" className={`${classes.title} ${isSubOpen ? classes.openTitle : ""}`}>{subcategory.name}</Typography>
          <Divider />
          <div className={classes.content}>
            <Typography variant="subtitle1"> Documentos: {subcategoryDocuments.length}</Typography>
            <div className={classes.actions}>
              <Button color="primary" variant="contained" onClick={this.handleOpenCategory(subcategory.id, subcategory, true)}>
                {isSubOpen ? "Cerrar" : "Abrir"}
              </Button>
              <Button disabled={cantEdit} color="primary" variant="outlined" onClick={this.handleOpenCreate(subcategory, true)}>
                <Backup />
              </Button>
            </div>
          </div>
        </div>
      )
    })
  }

  render() {
    const { classes, categories, signDocument } = this.props
    const {
      openCategory,
      category,
      openDialog,
      openWarning,
      document,
      editParams,
      params,
      openCreate,
      openNameWarning,
      isSubEdit,
      subcategory,
      selectedDocument,
      openSigns
    } = this.state
    const allSubcategories = category?.subcategories || []
    const selectedSubcategories = categories.find(cat => cat.id.toString() === editParams?.category_id?.toString())?.subcategories.concat([{ name: "Sin Sub-Carpeta", id: 0 }]) || []
    return (
      <div>
        <SignDocument document={selectedDocument} open={selectedDocument !== null} onClose={this.handleOpenSign(null)} onSubmit={signDocument} />
        <div className={classes.container}>
          {this.renderCategories()}
        </div>
        <Paper id="openDocument" className={`${classes.mainCategory} ${openCategory !== -1 ? classes.openMain : classes.closedMain}`} square>
          <Typography variant="h2" className={`${classes.title} ${classes.openTitle}`}>{`${category.name} ${subcategory ? `> ${subcategory.name}` : ""}`}</Typography>
          <div className={classes.files}>
            {this.renderCategoryFiles()}
          </div>
        </Paper>
        <Dialog open={openSigns !== null} fullWidth maxWidth="sm" onClose={this.handleOpenSigns(null)}>
          <Typography variant="h2" className={classes.signTitle}>Firmas del documento</Typography>
          <div className={classes.docSigns}>
            {this.renderSigns()}
          </div>
        </Dialog>
        <Dialog open={openDialog} fullWidth maxWidth="sm" onClose={this.handleOpenDialog()}>
          <Typography variant="h2" className={`${classes.title} ${classes.openTitle}`}>Editar Documento</Typography>
          <div className={classes.inputs}>
            <FileInput onChange={this.handleChangeEdit} label="Documento" name="file" value={editParams.file ? editParams.file.name : "Seleccionar Documento"} />
            <TextInput onChange={this.handleChangeEdit} label="Nombre (opcional)" name="name" value={editParams.name} />
            <Collapse in={openNameWarning}>
              <div className={classes.warningContainer}>
                <Typography variant="body1" className={classes.warning}>¡Ya existe un archivo con este nombre!</Typography>
                <Typography variant="caption" className={classes.warningLocation}>{`${openNameWarning?.category_name}  > ${openNameWarning?.name}`}</Typography>
              </div>
            </Collapse>
            <DateInput onChange={this.handleChangeEdit} label="Fecha" name="date" value={editParams.date} />
            <SelectInput onChange={this.handleChangeEdit} label="Carpeta" options={transformToOptions(categories)} name="category_id" value={editParams.category_id} />
            <Collapse in={selectedSubcategories.length > 0}>
              <SelectInput onChange={this.handleChangeEdit} label="Sub-Carpeta" options={transformToOptions(selectedSubcategories)} name="subcategory_id" value={editParams.subcategory_id} />
            </Collapse>
            <SubmitButton onClick={this.handleSendEdit}>Guardar</SubmitButton>
          </div>
        </Dialog>
        <Dialog open={openWarning} fullWidth maxWidth="sm" onClose={this.handleOpenWarning()}>
          <Typography variant="h2" className={`${classes.title} ${classes.openTitle}`}>Borrar Documento</Typography>
          <div className={classes.inputs}>
            <Typography variant="subtitle1">¿Estás seguro que deseas borrar este documento?</Typography>
            <div className={classes.file}>
              <Typography variant="h2" className={classes.doctTextTitle}>{document.name || "Sin nombre"}</Typography>
              <Typography variant="body2" className={classes.doctTextDownload} onClick={this.handleSeeDocument(document)}>Ver Documento</Typography>
              <Typography variant="body2" className={classes.doctText}>{document.category_name}</Typography>
            </div>
            <SubmitButton onClick={this.handleSendDelete}>Eliminar</SubmitButton>
          </div>
        </Dialog>
        <Dialog open={openCreate} fullWidth maxWidth="sm" onClose={this.handleOpenCreate()}>
          <Typography variant="h2" className={`${classes.title} ${classes.openTitle}`}>Agregar Documento</Typography>
          <div className={classes.inputs}>
            <FileInput onChange={this.handleChange} label="Documento" name="file" value={params.file ? params.file.name : "Seleccionar Documento"} />
            <TextInput onChange={this.handleChange} label="Nombre (opcional)" name="name" value={params.name} />
            <Collapse in={openNameWarning}>
              <div className={classes.warningContainer}>
                <Typography variant="body1" className={classes.warning}>¡Ya existe un archivo con este nombre!</Typography>
                <Typography variant="caption" className={classes.warningLocation}>{`${openNameWarning?.category_name}  > ${openNameWarning?.name}`}</Typography>
              </div>
            </Collapse>
            <DateInput onChange={this.handleChange} label="Fecha" name="date" value={params.date} />
            <SelectInput onChange={this.handleChange} label="Carpeta" options={transformToOptions(isSubEdit ? allSubcategories : categories)} name="category_id" value={params.category_id} disabled />
            <SubmitButton onClick={this.handleCreate}>Guardar</SubmitButton>
          </div>
        </Dialog>
      </div>
    )
  }
}

SubBranchDocuments.propTypes = {

}


SubBranchDocuments.defaultProps = {
  categories: []
}

const mapStateToProps = state => ({
  branch: state.branch,
  user: state.user
})

const mapDispatchToProps = dispatch => ({
  editSubBranchDocument: body => dispatch(editSubBranchDocumentAction(body)),
  deleteSubBranchDocument: body => dispatch(deleteSubBranchDocumentAction(body)),
  createSubBranchDocument: body => dispatch(createSubBranchDocumentAction(body)),
  signDocument: body => dispatch(signDocumentAction(body))
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withStyles(style)(SubBranchDocuments)))